export const alienRegistrationNumberParser = (value: string | null) => {
  if (!value) return null;
  const cleaned = value.replace(/[^A-Za-z0-9]/g, '').slice(0, 10);
  return cleaned === '' ? null : cleaned;
};

export const parseMonetaryValue = (value: string | number | null): number => {
  // NaN and Infinity can still number types, make sure they are actual values
  if (typeof value === 'number') return Number.isFinite(value) ? value : 0;
  if (value === null || value === '') return 0;

  const num = parseFloat(
    // Strip $, commas, spaces, etc.
    String(value).replace(/[^0-9.-]/g, ''),
  );

  return Number.isFinite(num) ? num : 0;
};
